<template>
<div style="">
<div v-if="isLoading" class="loading">Loading&#8230;</div> 

<div @click="show_students=!show_students" v-if="get_students_group_count(grpInfo.grpID) > 0" class="columns isLink has-background-white is-multiline is-gapless colBorder" style="padding:5px;">
            



<div class="column is-3">
<div class="columns is-gapless is-multiline">
        <div v-if="grpInfo.group_LANG=='F'" class="column is-12 has-text-weight-bold has-text-dark">&nbsp;&nbsp; {{grpInfo.cour_TITRE_F}} </div>
        <div v-else class="column is-12 has-text-weight-bold has-text-dark">&nbsp;&nbsp; {{grpInfo.cour_TITRE_E}} </div>  
        <div class="column is-3 has-text-centered has-text-weight-bold" style="border-right:1px solid gray;" :class="return_lang_style(grpInfo.group_LANG)">{{grpInfo.group_LANG}}</div>
        <div class="column is-9 has-text-weight-bold has-text-dark is-size-7 has-text-right"> {{grpInfo.group_datSTART | moment("MMM-DD-Y")}} : {{grpInfo.group_datEND | moment("MMM-DD-Y")}} </div>
</div></div>




        <div class="column is-3 has-text-centered has-text-weight-bold has-background-white">
            <span class="is-size-7 has-text-grey-light has-text-weight-light">Cnt.  </span>   {{get_students_group_count(grpInfo.grpID)}}
        </div> 

        <!-- <div v-if="get_students_group_count(grpInfo.grpID) <= get_tran_count_done_course('ICR',grpInfo.grpID)" class="column is-4 has-text-centered has-background-white" style="border-left:1px solid gray;">
             <span class="is-size-7 has-text-grey-light">ICR </span>   {{get_tran_count_done_course("ICR",grpInfo.grpID)}}    </div>  
        <div v-else class="column is-4 has-text-centered has-background-warning" style="border-left:1px solid gray;">
             <span class="is-size-7 has-text-grey-light">ICR </span>{{get_tran_count_done_course("ICR",grpInfo.grpID)}}    </div>            -->

<div class="column is-3 has-text-centered has-text-weight-bold" style="border-left:1px solid gray;">
        <span class="is-size-7 has-text-grey-light">ICR </span>
        <span :class="return_count_style(grpInfo.grpID , 'ICR')">&nbsp;&nbsp;&nbsp;&nbsp;{{get_tran_count_done_course("ICR",grpInfo.grpID)}}&nbsp;&nbsp;&nbsp;&nbsp;</span>
<span v-if="show_students"  @click="select_icr()" class="is-size-7 has-text-grey-light"> SELECT ALL </span>
</div>           

<div class="column is-3 has-text-centered has-text-weight-bold" style="border-left:1px solid gray;">
        <span class="is-size-7 has-text-grey-light">RCS </span>
        <span :class="return_count_style(grpInfo.grpID , 'RCS')">&nbsp;&nbsp;&nbsp;&nbsp;{{get_tran_count_done_course("RCS",grpInfo.grpID)}}&nbsp;&nbsp;&nbsp;&nbsp;</span>
</div> 


        <!-- <div v-if="get_students_group_count(grpInfo.grpID) <= get_tran_count_done_course('RCS',grpInfo.grpID)" class="column is-4 has-text-centered has-background-white" style="border-left:1px solid gray;">
              <span class="is-size-7 has-text-grey-light">RCS </span>  {{get_tran_count_done_course("RCS",grpInfo.grpID)}}  </div> 
        <div v-else class="column is-4 has-text-centered has-background-warning" style="border-left:1px solid gray;">
              <span class="is-size-7 has-text-grey-light">RCS </span>  {{get_tran_count_done_course("RCS",grpInfo.grpID)}}  </div>  -->


        </div>
 
 <div v-if="show_students" class="columns is-gapless is-multiline" style="margin-top:-1.6em">
 

    <!-- <div class="column is-6">  </div>
    <div @click="select_icr()" class="column button is-small has-text-centered is-size-7 has-text-info has-text-weight-bold is-3"> ICR </div>
    <div @click="select_rcs()" class="column button is-small has-text-centered is-size-7 has-text-info has-text-weight-bold is-3"> RCS </div> -->

        <div class="column is-12" v-for ="(info, index) in filter_students(grpInfo.grpID)" :key="index">
            <TranCourse
            :key="fakeIndex + index"
            :studGrp="info"
            :files="fileInfo"
            :selected_icr="selected_icr"
            :selected_rcs="selected_rcs"
            @emit_student_grp_click="emit_student_grp_click"
            @emit_student_grp_click_cancel="emit_student_grp_click_cancel"
            ></TranCourse>
        </div> 
</div>

</div>
</template>

<script>
import axios from 'axios';

import TranCourse  from '@/components/Comp_Tran_Course';
import js_transmit from '@/assets/js/js_transmit.js'
 
const openpgp = require('openpgp');
 
export default {
        props: [ 'grpInfo' , 'tranInfo', 'fileInfo' ],
        components: { TranCourse },

        data() {
            return {
                isLoading:false,
                show_students:false ,

fakeIndex:1, // USED TO REFRESH COMPONENT (!!)

selected_icr : false,
selected_rcs : false,

data_transmission:[],

            }
        },


methods: {


// GENERATE ID FOR TRANSACTION -- SAVE TO DB (NEW) 
randomTran_ID:function() {
return 'xxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
});},


select_icr:function(){
    this.selected_icr = !this.selected_icr

    var self = this
    this.tranInfo.forEach(function(item){ 
        
        if (item.grpID == self.grpInfo.grpID) {
            var id = 'ICR' + self.randomTran_ID()
            self.$emit("emit_tran_add", item, 'ICR', 'C' , id  )
        }
    });
    this.fakeIndex = this.fakeIndex + 1

},
select_rcs:function(){
    this.selected_rcs = !this.selected_rcs
},


test:function() {
alert('yo')
    axios.get(this.$url+'/send_email?addresses=michael@busmob.com, michael@michaelbatalha.com&subject=Hi-this is a test&msgText=Hi. Just checking to see if this makes it.&msgHtml=Hi. Just checking to see if this makes it.')
    .then(res => { 
        alert('done')
    });

// alert(this.data_transmission[0].data.cour_CODE)
// var xmlIPR = js_transmit.create_IPR('692580', '2020H', this.data_transmission)
// console.log(xmlIPR)
// axios.post(this.$url+'/create_xml?data='+encodeURIComponent(xmlIPR))
// .then(res => {
//     console.log(res.data)
// });

},



    emit_student_grp_click(data, tranTYPE, operation, tranID) {
// EMITTED FROM STUDENT-COURS  
// SEND UP THE CHAIN ....

this.$emit("emit_tran_add", this.tranInfo[data.indx], tranTYPE, operation, tranID  )

        // this.data_transmission.push({ 
        //     data : this.tranInfo[data.indx],
        //     tranTYPE : tranTYPE, 
        //     operation : operation
        // })

    } ,
    emit_student_grp_click_cancel(tranID) {
// EMITTED FROM STUDENT-COURS -- REMOVE STUDENT FROM ARAY
   this.$emit("emit_tran_remove", tranID)

    

        // var i = 0 ; var self = this
        // this.data_transmission.forEach(function(item){ 
        //     if (item.studID == studID && this.data_transmission.grpID == grpID && this.data_transmission.tranTYPE == tranTYPE )
        //     {self.data_transmission.splice(i,1) ; return}
        //     else { i++ }
        // })

  
    } ,

    filter_students:function(grpID) {
// GET STUDENTS FOR GROUP
    var student_filter=[]
    this.tranInfo.forEach(function(item, indx){ 
        if (item.grpID == grpID) {
            var s_object = {};
            s_object.indx = indx,
            s_object.studID = item.studID,
            s_object.grpID = item.grpID,
            s_object.student_lNAME = item.student_lNAME,
            s_object.student_fNAME = item.student_fNAME,
            s_object.student_GRPCODE=item.student_GRPCODE,
            s_object.student_PhotoPath =item.student_PhotoPath,
            s_object.student_CodePerm=item.student_CodePerm,
            s_object.student_CreateDate=item.student_CreateDate
            student_filter.push(s_object);       
        }
    }); // END LOOP
        return student_filter
    },

    get_students_group:function(grpID,index) {
    // GET ALL STUDENTS IN GROUP SELECTED
        this.activeMenu = index
    },

    get_students_group_count:function(grpID) {
    // GET ALL STUDENTS IN GROUP SELECTED
    var cnt = 0;
    this.tranInfo.forEach(function(item){ 
        if (item.grpID == grpID) {
            cnt += 1     
        }
    }); // END LOOP
    return cnt
    },

    get_tran_count_done_course:function(type ,grpID) {
    // GET ALL STUDENTS IN GROUP SELECTED
    var cnt = 0;
    this.fileInfo.forEach(function(item){
        if (item.tran_TYPE == type && item.group_ID == grpID && item.fileTran_PROCESSED && !item.tran_bERROR) {
            cnt += 1     
        }
    }); // END LOOP
    return cnt
    },


return_count_style:function(grp, type) {



    if (this.get_tran_count_done_course(type,grp) == 0) {
        return 'has-background-white has-text-dark'
    } else if (this.get_students_group_count(grp) == this.get_tran_count_done_course(type,grp)) {
        return 'has-background-success has-text-white' //'background-color:#95BBCC;'
    } else {
        return 'has-background-warning has-text-dark' //'background-color:#FFD3DA;'
    }
}, // END RETURN COUNT STYLE


return_lang_style:function(lang) {
  if (lang == "F") {
    return 'has-background-link has-text-white' //'background-color:#95BBCC;'
  } else {
    return 'has-background-danger has-text-white' //'background-color:#FFD3DA;'
  }
}, // END RETURN LANG STYLE

// GENERATE A NEW ID! 
    randomKey:function() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });},

}, // END METHODS

}

</script>
